__turbopack_context__.v({
  "active": "index-module-scss-module__BIZhfq__active",
  "headerContainer": "index-module-scss-module__BIZhfq__headerContainer",
  "logo": "index-module-scss-module__BIZhfq__logo",
  "scrolled": "index-module-scss-module__BIZhfq__scrolled",
});
